import { Reveal } from "@/components/Reveal";
import { IubendaEmbed } from "@/components/IubendaEmbed";

const IUBENDA = {
  privacy: {
    label: "Legale",
    title: "Privacy Policy",
    href: "https://www.iubenda.com/privacy-policy/66098362",
    intro: "Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR).",
  },
  cookie: {
    label: "Legale",
    title: "Cookie Policy",
    href: "https://www.iubenda.com/privacy-policy/66098362/cookie-policy",
    intro: "Informativa sull'uso dei cookie e degli strumenti di tracciamento.",
  },
};

const TERMS = {
  label: "Legale",
  title: "Termini & Condizioni",
  intro: "Condizioni di utilizzo del sito.",
  body: [
    ["Oggetto", "Questo sito è una vetrina di presentazione dei servizi di consulenza di 2e Lab, Valentina Garavaglia. Non costituisce offerta al pubblico né contratto."],
    ["Contatti", "Le richieste inviate tramite il form sono trattate secondo la Privacy Policy e servono unicamente a ricontattarti. Nessun acquisto o pagamento avviene su questo sito."],
    ["Proprietà intellettuale", "Contenuti, testi, logo e materiali del sito sono di proprietà di 2e Lab e non possono essere riprodotti senza autorizzazione."],
  ],
};

export default function Legal({ kind }) {
  if (kind === "terms") {
    const c = TERMS;
    return (
      <div data-testid="legal-terms-page" className="pt-32 md:pt-44 pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="font-mono2 text-xs uppercase tracking-widest text-darkgrey mb-6">{c.label}</p>
            <h1 className="font-heading text-5xl md:text-6xl leading-[0.95]">{c.title}</h1>
            <p className="font-editorial text-2xl text-darkgrey mt-6 leading-relaxed">{c.intro}</p>
          </Reveal>
          <div className="mt-14 space-y-10 border-t border-darkgrey/30 pt-10">
            {c.body.map(([h, p], i) => (
              <Reveal key={h} delay={i * 0.04}>
                <h2 className="font-heading text-2xl mb-2">{h}</h2>
                <p className="font-body text-darkgrey leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    );
  }

  const c = IUBENDA[kind];
  return (
    <div data-testid={`legal-${kind}-page`} className="pt-32 md:pt-44 pb-24 md:pb-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono2 text-xs uppercase tracking-widest text-darkgrey mb-6">{c.label}</p>
          <h1 className="font-heading text-5xl md:text-6xl leading-[0.95]">{c.title}</h1>
          <p className="font-editorial text-2xl text-darkgrey mt-6 leading-relaxed">{c.intro}</p>
        </Reveal>
        <div className="mt-12 border-t border-darkgrey/30 pt-10 iubenda-embed-container">
          <IubendaEmbed href={c.href} title={c.title} />
        </div>
      </div>
    </div>
  );
}
